export const DeliveryIconOtherDaysV2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M6.46933 10.1875H5.86914V13.3048H6.46933V10.1875Z" fill="#077769" />
      <path
        d="M6.43194 13.301C7.21091 13.301 7.84239 12.604 7.84239 11.7442C7.84239 10.8845 7.21091 10.1875 6.43194 10.1875C5.65297 10.1875 5.02148 10.8845 5.02148 11.7442C5.02148 12.604 5.65297 13.301 6.43194 13.301Z"
        fill="#085F54"
      />
      <path
        d="M5.92217 13.301C6.70114 13.301 7.33262 12.604 7.33262 11.7442C7.33262 10.8845 6.70114 10.1875 5.92217 10.1875C5.1432 10.1875 4.51172 10.8845 4.51172 11.7442C4.51172 12.604 5.1432 13.301 5.92217 13.301Z"
        fill="#077769"
      />
      <path
        d="M5.87038 12.2331C6.11484 12.2331 6.31302 12.0148 6.31302 11.7455C6.31302 11.4761 6.11484 11.2578 5.87038 11.2578C5.62591 11.2578 5.42773 11.4761 5.42773 11.7455C5.42773 12.0148 5.62591 12.2331 5.87038 12.2331Z"
        fill="white"
      />
      <path d="M12.8111 10.1875H12.2109V13.3048H12.8111V10.1875Z" fill="#077769" />
      <path
        d="M12.7737 13.301C13.5527 13.301 14.1842 12.604 14.1842 11.7442C14.1842 10.8845 13.5527 10.1875 12.7737 10.1875C11.9948 10.1875 11.3633 10.8845 11.3633 11.7442C11.3633 12.604 11.9948 13.301 12.7737 13.301Z"
        fill="#085F54"
      />
      <path
        d="M12.264 13.301C13.0429 13.301 13.6744 12.604 13.6744 11.7442C13.6744 10.8845 13.0429 10.1875 12.264 10.1875C11.485 10.1875 10.8535 10.8845 10.8535 11.7442C10.8535 12.604 11.485 13.301 12.264 13.301Z"
        fill="#077769"
      />
      <path
        d="M12.2122 12.2331C12.4566 12.2331 12.6548 12.0148 12.6548 11.7455C12.6548 11.4761 12.4566 11.2578 12.2122 11.2578C11.9677 11.2578 11.7695 11.4761 11.7695 11.7455C11.7695 12.0148 11.9677 12.2331 12.2122 12.2331Z"
        fill="white"
      />
      <path
        d="M0 4.43848V10.8755C0 11.3595 0.390122 11.7496 0.874023 11.7496H8.50362C8.98752 11.7496 9.37764 11.3595 9.37764 10.8755V6.18654C9.37764 5.70264 9.76777 5.31251 10.2517 5.31251H10.9269C11.4108 5.31251 11.8009 4.92239 11.8009 4.43848C11.8009 3.95458 11.4108 3.56445 10.9269 3.56445L0.874023 3.56445C0.390122 3.56445 0 3.95458 0 4.43848Z"
        fill="#077769"
      />
      <path
        d="M0 3.87403V10.0866C0 10.5705 0.390122 10.9606 0.874023 10.9606H8.56694C9.05084 10.9606 9.44096 10.5705 9.44096 10.0866V6.18573C9.44096 5.70183 9.83108 5.3117 10.315 5.3117H10.9902C11.4741 5.3117 11.7241 5.25432 11.7238 3.87403C11.7238 3.39013 11.3337 3 10.8498 3H0.874023C0.390122 3 0 3.39013 0 3.87403Z"
        fill="#229C8B"
      />
      <path
        d="M9.1444 6.30191C9.1444 5.69668 9.63503 5.20605 10.2403 5.20605H13.96C14.2447 5.20605 14.5182 5.31684 14.7227 5.51497L15.6124 6.37727C15.8254 6.58368 15.9457 6.86761 15.9457 7.16421V10.4687C15.9457 10.8408 15.762 11.1889 15.4549 11.399L14.8963 11.7812H9.1444"
        fill="#229C8B"
      />
      <path
        d="M15.7424 6.57715H13.291V11.7824H14.8309C15.4534 11.7824 15.9581 11.2781 15.9581 10.6556V7.39904C15.9581 7.17987 16.0163 6.85111 15.7424 6.57715Z"
        fill="#077769"
      />
      <path d="M2.97519 10.1875H2.375V13.3048H2.97519V10.1875Z" fill="#077769" />
      <path
        d="M2.93584 13.301C3.71481 13.301 4.3463 12.604 4.3463 11.7442C4.3463 10.8845 3.71481 10.1875 2.93584 10.1875C2.15687 10.1875 1.52539 10.8845 1.52539 11.7442C1.52539 12.604 2.15687 13.301 2.93584 13.301Z"
        fill="#085F54"
      />
      <path
        d="M2.42608 13.301C3.20505 13.301 3.83653 12.604 3.83653 11.7442C3.83653 10.8845 3.20505 10.1875 2.42608 10.1875C1.64711 10.1875 1.01562 10.8845 1.01562 11.7442C1.01562 12.604 1.64711 13.301 2.42608 13.301Z"
        fill="#077769"
      />
      <path
        d="M2.3741 12.3479C2.67671 12.3479 2.92202 12.0777 2.92202 11.7443C2.92202 11.4109 2.67671 11.1406 2.3741 11.1406C2.07149 11.1406 1.82617 11.4109 1.82617 11.7443C1.82617 12.0777 2.07149 12.3479 2.3741 12.3479Z"
        fill="white"
      />
      <path
        d="M9.42007 3C8.81485 3 8.32422 3.49063 8.32422 4.09585V10.9609L9.14611 10.687V6.30356C9.14611 5.69834 9.63674 5.20771 10.242 5.20771H11.4841C11.7046 5.20771 11.8857 5.03436 11.8857 4.82333V3.38438C11.8857 3.17335 11.7046 3 11.4841 3H9.42007Z"
        fill="#077769"
      />
      <path d="M10.0084 10.248H9.4082V13.3653H10.0084V10.248Z" fill="#077769" />
      <path
        d="M9.96905 13.3615C10.748 13.3615 11.3795 12.6646 11.3795 11.8048C11.3795 10.945 10.748 10.248 9.96905 10.248C9.19007 10.248 8.55859 10.945 8.55859 11.8048C8.55859 12.6646 9.19007 13.3615 9.96905 13.3615Z"
        fill="#085F54"
      />
      <path
        d="M9.46123 13.3615C10.2402 13.3615 10.8717 12.6646 10.8717 11.8048C10.8717 10.945 10.2402 10.248 9.46123 10.248C8.68226 10.248 8.05078 10.945 8.05078 11.8048C8.05078 12.6646 8.68226 13.3615 9.46123 13.3615Z"
        fill="#077769"
      />
      <path
        d="M9.4073 12.4104C9.70991 12.4104 9.95523 12.1402 9.95523 11.8068C9.95523 11.4734 9.70991 11.2031 9.4073 11.2031C9.10469 11.2031 8.85938 11.4734 8.85938 11.8068C8.85938 12.1402 9.10469 12.4104 9.4073 12.4104Z"
        fill="white"
      />
      <path
        d="M12.3332 7.29492C11.9333 7.29492 11.6681 7.70953 11.8358 8.07262L12.3902 9.27281C12.4798 9.46677 12.674 9.59097 12.8876 9.59097H15.9236L15.9396 7.29492H12.3332Z"
        fill="white"
      />
      <path d="M13.2559 9.5915V7.29492H16.0007V9.5915H13.2559Z" fill="#F4F4F4" />
    </svg>
  );
};
